/**
 * Work-item reference extraction (UCH-149). Patterns are word-bounded so
 * UCHAT3-12 never matches UCHAT-*, and UCH-* never matches inside UCHAT-*.
 * References may appear in PR titles/bodies and commit subjects/bodies; absence
 * of a reference is fine and carries no warning.
 */
const CLICKUP_LEGACY = /\bUCHAT-\d+\b/gi;
const CLICKUP_NEW = /\bUCHAT3-\d+\b/gi;
const LINEAR = /\bUCH-\d+\b/gi;

export interface ExtractedRefs {
  clickup: string[];
  linear: string[];
}

export const extractWorkItemRefs = (texts: readonly string[]): ExtractedRefs => {
  const clickup = new Set<string>();
  const linear = new Set<string>();
  for (const text of texts) {
    for (const m of text.matchAll(CLICKUP_LEGACY)) clickup.add(m[0].toUpperCase());
    for (const m of text.matchAll(CLICKUP_NEW)) clickup.add(m[0].toUpperCase());
    for (const m of text.matchAll(LINEAR)) linear.add(m[0].toUpperCase());
  }
  return { clickup: [...clickup].sort(), linear: [...linear].sort() };
};
